export const examAdminRolePermissions = {
  catalogTitle: "ロールカタログ",
  catalogLoadFailed: "ロールカタログの読み込みに失敗しました",
  catalogContractInvalid: "ロールカタログ契約の異常",
  catalogContractDescription:
    "バックエンドは role-catalog.roles 配列を明示的に返す必要があります。開発モードでは空のカタログにフォールバックしません。",
  matrixTitle: "権限マトリクス",
  matrixBlocked: "ロールカタログ異常のため権限マトリクスを停止しました",
  permissionColumn: "権限",
  allowed: "許可",
  denied: "拒否",
  status: {
    active: "有効",
    inactive: "無効",
  },
  permissions: {
    dashboard: "ワークベンチ",
    candidateUsers: "受験者ディレクトリ",
    users: "ユーザー管理",
    resetUserPassword: "ユーザーパスワードリセット",
    impersonateCandidate: "受験者として操作",
    system: "システム設定",
    auditLogs: "監査ログ",
    questions: "問題バンク管理",
    archiveQuestions: "問題をアーカイブ",
    deleteQuestions: "問題を削除",
    publishQuestions: "問題を公開",
    questionExperience: "問題体験ガバナンス",
    papers: "試験用紙管理",
    exams: "試験管理",
    execution: "実行監視",
    docker: "環境インスタンス",
    assets: "アセットセンター",
    review: "採点レビュー",
  },
};
